import React from "react";
import { List, Typography } from "antd";
import StateTag from "Components/state-tag";
import OperationsColumn from "./operations-column";

export default function PartnersList({
  IsAuthorized,
  data,
  loading,
  onOperationExecuted,
  onSetFilteredValue,
  ...props
}) {
  const getPartnerRoles = (item) => {
    let roles = [];
    item.partnerRoles.forEach((role) => {
      roles.push(role.type.description);
    });

    return roles.toString();
  };

  return (
    <List
      dataSource={data}
      style={{ backgroundColor: "#fff" }}
      bordered
      locale={{
        emptyText: IsAuthorized
          ? "Kayıt Bulunamadı"
          : "Bu işlem için yetkiniz yok. Sistem yöneticiniz ile iletişime geçebilirsiniz.",
      }}
      pagination={{
        pageSize: 20,
        showSizeChanger: false,
        total: data.length,
        showTotal: (total, range) =>
          `Toplam ${total} sonuçtan ${range.join("-")} arası gösteriliyor.`,
      }}
      renderItem={(item, index) => {
        return (
          <List.Item
            className="customized"
            style={{ position: "relative" }}
            key={item.id}
          >
            <List.Item.Meta
              title={
                <>
                  <Typography.Text strong>
                    {item.name + " " + item.surname}
                  </Typography.Text>
                  <StateTag state={item.state} />
                </>
              }
              description={getPartnerRoles(item)}
            />
            <div
              style={{
                position: "absolute",
                top: 12,
                right: 0,
                marginRight: 7,
              }}
            >
              {
                <OperationsColumn
                  record={item}
                  onOperationExecuted={onOperationExecuted}
                />
              }
            </div>
            {item.address}
            <br />
            {item.email}
            <br />
            {item.phone || " "}
          </List.Item>
        );
      }}
    />
  );
}
